<ion-content class="hover-ref" *transloco="let t; prefix: 'lessonPopover'">
    <ion-grid class=" share-wrapper ion-no-padding" *ngIf="isSharePopover">
        <ion-list [inset]="false">
            <ion-item (click)="shareViaFacebookMessenger(this.refUrl)" *ngIf="!this.isTestShare">
                <ion-label>
                    <img alt="coins" src="assets/images/icons/social/facebook.svg"/>
                    Facebook
                </ion-label>
            </ion-item>
            <ion-item (click)="shareViaTelegram(this.refUrl)">
                <ion-label>
                    <img alt="coins" src="assets/images/icons/social/telegram.svg"/>
                    Telegram
                </ion-label>
            </ion-item>
            <ion-item  (click)="shareViaViber(this.refUrl)">
                <ion-label>
                    <img alt="coins" src="assets/images/icons/social/viber.svg"/>
                    Viber
                </ion-label>
            </ion-item>
        </ion-list>
    </ion-grid>


</ion-content>
